import { default as Tooltip } from './tooltip'

export default Tooltip

export { Tooltip }
